// Basic
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useRemoteCollectionStore from '@/app/store/modules/remoteCollection';
import useRootOrganizationStore from '@/app/store/rootOrganization';
import actionsRemoteCollections from '../../api/actionsRemoteCollections';
// Components
import DataTable from '../../../../../common-utils/components/renders/dataTable/DataTable';
// Common
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import mergeQuery from '@/common-utils/components/renders/dataTable/utils/mergeQuery';
import Permissions from '@/app/permissions/Permissions';
import { columnsRemoteCollections, columnsRemoteCollectionsId } from './columnDef/columnsRemoteCollections';
import { POS_TERMINALS } from '@/app/modules/terminals/api/apiUrls';

/**
 * @param root0
 * @param root0.posTerminalId
 * @param root0.filtersEventName
 * @returns {JSX} TerminalRemoteCollectionsTable
 */
function TerminalRemoteCollectionsTable({ posTerminalId, filtersEventName }) {
    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);
    const { refetchRemoteCollections: refetchFromStore, storeRefetchRemoteCollections, query: queryStored, storeQuery } = useRemoteCollectionStore();

    // Constants
    const initialQuery = getInitialQuery();

    // State
    const [query, setQuery] = useState(mergeQuery(initialQuery, queryStored));
    const [launchRefetch, setLaunchRefetch] = useState(true);

    // Api Calls
    const { data, isFetching, refetch } = actionsRemoteCollections.getTerminalRemoteCollections(query, posTerminalId, false);

    // Hooks
    useEffect(() => {
        if (rootOrganization && (launchRefetch || refetchFromStore)) {
            refetch();
            setLaunchRefetch(false);
            storeRefetchRemoteCollections(false);
        }
    }, [query, launchRefetch, refetchFromStore]);

    const allColumns = columnsRemoteCollections({ query, setQuery, queryStored, storeQuery, setLaunchRefetch, filtersEventName });

    // Render
    return (
        <DataTable
            filtersEventName={filtersEventName}
            columns={allColumns}
            data={data}
            dataFetchingIsLoading={isFetching}
            columnsId={columnsRemoteCollectionsId}
            initialQuery={initialQuery}
            query={query}
            setQuery={setQuery}
            queryStored={queryStored}
            storeQuery={storeQuery}
            setLaunchRefetch={setLaunchRefetch}

            exportProps={{
                permissions: [
                    Permissions.EXPORT_POS_TERMINAL_REMOTE_COLLECTIONS.name
                ],
                api: POS_TERMINALS.EXPORT_REMOTE_COLLECTIONS,
                uuid: posTerminalId
            }}
        />
    );
}

TerminalRemoteCollectionsTable.propTypes = {
    posTerminalId: PropTypes.string,
    filtersEventName: PropTypes.string
};

export default TerminalRemoteCollectionsTable;